import React from "react";
import ReactDOM from "react-dom/client";
import store from "./Redux/store";
import { Provider } from 'react-redux';

import "./index.css";
import "pepsico-ds/css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { LoadingProvider } from "./loader";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <LoadingProvider store={store}>
      <App />
    </LoadingProvider>
  </Provider>
);

reportWebVitals();
